import React from 'react';
import { Container } from 'react-bootstrap';
// import '../Sweepstakes/Sweepstakes.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <div className="Sweepstakes_bg">
        <Container className="py-5 text-light">
          <article>
            <header>
              <h1>Terms And Conditions</h1>
              <p><strong>Big Bucks Terms and Conditions</strong></p>
              <p><strong>Date of Last Update:</strong> 03 September 2024</p>
            </header>

            {/* Introductory Section */}
            <section>
              <p>
                These Terms and Conditions form a binding legal agreement between you and us and apply to your use of any of our Games or our Platform in any way, through any electronic device (web, mobile, tablet or any other device).
              </p>
              <p>
                <strong>PLEASE NOTE:</strong> These Terms and Conditions include a provision waiving the right to pursue any class, group or representative claim and requiring you to pursue past, pending, and future disputes between you and us through individual arbitration unless you opt out within the specified time frame. See Clause 22 for more information.
              </p>
              <p>
                You must read these Terms and Conditions carefully in their entirety. Using our product, requesting free credits, creating an account, or purchasing credits are all considered express agreement to our terms. By checking the box for acceptance during registration, or by accessing the Games or creating a Customer Account, you confirm that you have read and agree to be bound by these Terms and Conditions and any other game- or promotion-specific terms relevant to your participation. If you do not agree with any provision, you may not install or use the Platform or play any Game.
              </p>
              <p>
                <strong>THE GAMES AND PLATFORM DO NOT OFFER REAL MONEY GAMBLING, AND NO ACTUAL MONEY IS REQUIRED TO PLAY.</strong>
              </p>
              <p>
                <strong>ONLY PLAYERS IN THE UNITED STATES (EXCLUDING THE STATES OF IDAHO AND WASHINGTON) AND CANADA (EXCLUDING QUEBEC) ARE ELIGIBLE TO ENTER THE SWEEPSTAKES.</strong> Please refer to Clause 1.1 of the Sweeps Rules to check your eligibility.
              </p>
              <p>
                <strong>YOU CAN REQUEST REDEMPTION OF ANY PRIZES</strong> by chatting with our team at{' '}
                <a href="https://m.me/bigbucksfishingroom" target="_blank" rel="noopener noreferrer">
                  M.ME/Big Bucks
                </a>. When players redeem prizes for gift cards, those prizes will be allocated through an electronic payment to the bank account you have designated.
              </p>
            </section>

            {/* Definitions */}
            <section>
              <h2>Definitions</h2>
              <dl>
                <dt>Collective Arbitration</dt>
                <dd>
                  Any claim as part of a class, group, collective, coordinated, consolidated, mass, or representative proceeding.
                </dd>
                <dt>Content</dt>
                <dd>
                  Text, graphics, user interfaces, visual interfaces, photographs, trademarks, logos, sounds, music, artwork, computer code and other material used, displayed, or available as part of the Games and Platform. Content includes credits.
                </dd>
                <dt>Customer Account</dt>
                <dd>An account held by a Registered Customer.</dd>
                <dt>Excluded Territory</dt>
                <dd>
                  The state of Washington and Idaho in the United States, as well as any outlying U.S. territories or possessions, the province of Quebec in Canada, and any other jurisdiction outside of the United States and Canada.
                </dd>
                <dt>Fraudulent Conduct</dt>
                <dd>Any of the conduct described in clause 11.1.</dd>
                <dt>Game</dt>
                <dd>
                  Any one or more Game(s) available on the Platform in either Standard Play or Promotional Play. We reserve the right to add and remove Games from the Platform at our sole discretion.
                </dd>
                <dt>Inactive Account</dt>
                <dd>
                  A Customer Account which has not recorded any log in or log out for a period exceeding 12 consecutive months.
                </dd>
                <dt>Merchandise</dt>
                <dd>
                  Any physical goods provided to you by Big Bucks Games as a reward or as a competition or tournament prize.
                </dd>
                <dt>Participate</dt>
                <dd>
                  Playing any Games or using our Platform in any manner whatsoever, including any of the conduct described in clause 3.
                </dd>
                <dt>Payment Administration Agent</dt>
                <dd>
                  The service provided through any related body corporate, affiliate, or third party we appoint to act as our agent, including but not limited to Big Bucks Games and Andhera Deals.
                </dd>
                <dt>Payment Medium</dt>
                <dd>
                  Any card, online wallet, financial/bank account, or other payment medium used to purchase credits.
                </dd>
                <dt>Platform</dt>
                <dd>
                  The services provided through any URL or mobile application belonging to, or licensed to, Andhera Deals, and branded as part of the “Big Bucks Games” family of games, including the website located at{' '}
                  <a href="https://bigbucksfishingroom.com/" target="_blank" rel="noopener noreferrer">
                  bigbucksfishingroom
                  </a>
                  , and all subdomains, subpages, and successor sites, as well as all Games, features, tools, and services available thereon.
                </dd>
                <dt>Player or you</dt>
                <dd>Any person who Participates, whether or not a Registered Customer.</dd>
                <dt>Player Support Team</dt>
                <dd>
                  Performs the Player Support Function and has the meaning given in section 39(1) of the Player Protection Directive.
                </dd>
                <dt>Prizes</dt>
                <dd>
                  Prizes won when playing Promotional Play Games which are redeemable for valuable prizes in accordance with the Sweeps Rules.
                </dd>
                <dt>Promotional Play</dt>
                <dd>
                  Participation in our sweepstakes promotions by playing any games on the Platform with credits.
                </dd>
                <dt>Registered Customer</dt>
                <dd>
                  A Player who has successfully registered a Customer Account, whether that account is considered active or not.
                </dd>
                <dt>Standard Play</dt>
                <dd>
                  Participating in any game on the Platform played with credits. You may be given credits free of charge when you sign up and thereafter at regular intervals. You may win more credits in Standard Play, and you may purchase more credits on the Platform. Note that you cannot win prizes when participating in Standard Play.
                </dd>
                <dt>credits</dt>
                <dd>
                  Sweepstakes entries subject to the Sweeps Rules. We may give you credits free of charge when you sign up or as a bonus when you purchase credits or through alternative methods of entry set out in the Sweeps Rules. <strong>YOU CANNOT PURCHASE credits.</strong>
                </dd>
                <dt>Sweeps Rules</dt>
                <dd>The Sweeps Rules available on the Platform.</dd>
                <dt>Terms and Conditions</dt>
                <dd>These terms and conditions, as amended from time to time.</dd>
                <dt>Andhera Deals, we, us or our</dt>
                <dd>Means Big Bucks Games and Andhera Deals.</dd>
                <dt>Big Bucks Games</dt>
                <dd>Means Andhera Deals, a limited liability company incorporated.</dd>
              </dl>
            </section>

            {/* Licensing Section */}
            <section>
              <h2>Licensing and the Protection of Funds</h2>
              <p>
                Funds equal to the aggregate value of Prizes which Registered Customers have chosen to leave unredeemed are held by Big Bucks Games in accounts separate from its business account. This measure is taken to protect such funds; however, in the event of insolvency, there is no absolute guarantee that any unredeemed Prizes will be allocated or paid.
              </p>
            </section>

            {/* Your Participation Section */}
            <section>
              <h2>Your Participation</h2>
              <h3>Restrictions</h3>
              <ul>
                <li>
                  You declare and warrant that:
                  <ul>
                    <li>
                      You are over 18 years of age or the applicable legal age of majority in your jurisdiction and are legally allowed to participate in the Games.
                    </li>
                    <li>
                      <strong>Standard Play:</strong> You do not reside in or access the Platform from the Excluded Territories.
                    </li>
                    <li>
                      <strong>Promotional Play:</strong> You do not reside in or access the Platform from the Excluded Territories or Idaho.
                    </li>
                    <li>
                      You participate in the Games strictly for recreational and entertainment purposes.
                    </li>
                    <li>
                      You participate on your own behalf and not on behalf of any other person.
                    </li>
                    <li>
                      All information provided to us is true, complete, and correct, and you will notify us of any changes.
                    </li>
                    <li>
                      Money used to purchase credits is not tainted by any illegal activity.
                    </li>
                    <li>
                      You will purchase credits only through an account held in your name.
                    </li>
                    <li>
                      You will not engage in any fraudulent or unlawful activities related to your or third parties’ participation in the Games, including using any automated software.
                    </li>
                    <li>
                      For credit purchases, you must use a valid Payment Medium that lawfully belongs to you.
                    </li>
                    <li>
                      You will not sell, trade, or otherwise exchange any Merchandise provided by Big Bucks Games.
                    </li>
                  </ul>
                </li>
              </ul>
              <p>
                <strong>Note:</strong> Credit purchases made from within the states of Washington and Idaho will be voided and refunded, minus an administrative fee of up to 10%, plus any bank or financial institution charges.
              </p>
              <p>
                It is your responsibility to ensure that your participation is lawful in your jurisdiction. Any breach—including the use of VPNs or proxies to mask your location—may result in legal action.
              </p>
            </section>

            {/* Eligible Players Section */}
            <section>
              <h2>Eligible Players</h2>
              <p>
                Employees of Andhera Deals (or its affiliates, subsidiaries, or related companies), their immediate family members, and household members (those sharing the same residence for at least 3 months) are not eligible to participate.
              </p>
            </section>

            {/* License Section */}
            <section>
              <h2>License</h2>
              <p>
                Subject to your agreement and continued compliance with these Terms and Conditions, Andhera Deals grants you a personal, non-exclusive, non-transferable, revocable, and limited license to access and use the Platform and its Content solely for personal entertainment. This license does not grant you any ownership rights in the Platform or Content and may be terminated if you fail to comply with these Terms.
              </p>
            </section>

            {/* Games Section */}
            <section>
              <h2>Games</h2>
              <h3>Rules</h3>
              <p>
                Games on the Platform may have additional rules. It is your responsibility to read and understand the rules of any Game before playing.
              </p>
            </section>

            {/* Promotions Section */}
            <section>
              <h2>Promotions</h2>
              <p>
                All promotions—including contests, special offers, and bonus events—are subject to these Terms and Conditions, the Sweeps Rules, and any additional promotion-specific terms. In case of conflict, the promotion-specific terms prevail.
              </p>
            </section>

            {/* Redemption Section */}
            <section>
              <h2>Redemption of Prizes</h2>
              <p>
                When you choose to redeem Prizes:
              </p>
              <ul>
                <li>
                  Gift cards will be allocated to the email address registered with your Customer Account, or to an alternative if necessary.
                </li>
                <li>
                  Cash payments will be made to the Payment Medium used to purchase credits (or an alternative account if possible).
                </li>
                <li>
                  We reserve the right to require the same payment method for redemption as was used for the purchase.
                </li>
              </ul>
            </section>

            {/* Verification Section */}
            <section>
              <h2>Verification</h2>
              <p>
                You agree that we may conduct identification and verification checks (e.g., requesting proof of identity, address, or source of funds) as required by law. Until verification is complete, redemption requests may be held and your Customer Account may be restricted.
              </p>
            </section>

            {/* Responsible Social Gameplay Section */}
            <section>
              <h2>Responsible Social Gameplay</h2>
              <p>
                Big Bucks Games encourages responsible social gameplay and provides features to help manage your Customer Account. While we enforce these policies, we are not liable if you deliberately bypass them.
              </p>
            </section>

            {/* Fraudulent Conduct Section */}
            <section>
              <h2>Fraudulent Conduct</h2>
              <p>
                You must not hack, modify, reverse-engineer, or otherwise interfere with the Platform. Engaging in any fraudulent activity may result in immediate suspension or closure of your Customer Account.
              </p>
            </section>

            {/* Intellectual Property Section */}
            <section>
              <h2>Intellectual Property</h2>
              <p>
                The software, graphics, Platform, and user interface provided by Big Bucks Games are either owned by or licensed to us and are protected by copyright and trademark laws. Your use of the Platform does not grant you any rights in these materials.
              </p>
            </section>

            {/* Third Party Section */}
            <section>
              <h2>Third Party Websites, Links, or Games</h2>
              <p>
                Andhera Deals is not responsible for the content or functionality of third-party websites linked from our Platform. Such links do not imply endorsement, and any transactions with third parties are solely between you and the third party.
              </p>
            </section>

            {/* Disruptions and Changes Section */}
            <section>
              <h2>Disruptions and Changes</h2>
              <p>
                The Platform is provided on an "as is" basis without warranties of any kind. Big Bucks Games is not liable for technical issues, interruptions, or errors. We will use reasonable efforts to correct any problems.
              </p>
            </section>

            {/* Privacy and Marketing Section */}
            <section>
              <h2>Privacy Policy &amp; Marketing Communications</h2>
              <p>
                Our Privacy Policy is an integral part of these Terms and Conditions. By using the Platform, you consent to receive marketing communications from Big Bucks Games, which you may unsubscribe from at any time.
              </p>
            </section>

            {/* Live Chat Section */}
            <section>
              <h2>Use of Live Chat Services</h2>
              <p>
                If available, live chat services are provided for customer support and social interactions only. Please use these services responsibly. We reserve the right to monitor and moderate chat content.
              </p>
            </section>

            {/* Complaints and Support Section */}
            <section>
              <h2>Complaints and Customer Support</h2>
              <p>
                For any complaints or support queries, please contact our Customer Support using the email address registered with your Customer Account. Include your username, full name, detailed explanation, and any relevant dates.
              </p>
            </section>

            {/* Account Suspension Section */}
            <section>
              <h2>Closure/Suspension of Account</h2>
              <p>
                We reserve the right to suspend or close your Customer Account at our discretion for reasons including breach of these Terms, fraudulent activity, or misuse of the Platform. In such cases, you may be liable for any resulting losses.
              </p>
            </section>

            {/* Indemnity and Liability Section */}
            <section>
              <h2>Indemnity and Limitation of Liability</h2>
              <p>
                You agree to indemnify Big Bucks Games and its affiliates against any claims arising from your use of the Platform. Our liability, to the maximum extent permitted by law, is limited to the amount you have paid in the 30 days immediately preceding any claim.
              </p>
            </section>

            {/* Dispute Resolution Section */}
            <section>
              <h2>Dispute Resolution</h2>
              <p>
                You and Big Bucks Games agree to resolve disputes through individual arbitration under the Federal Arbitration Act. Class or collective actions are not permitted.
              </p>
            </section>

            {/* Other Section */}
            <section>
              <h2>Other</h2>
              <p>
                These Terms and Conditions constitute the entire agreement between you and Big Bucks Games. We reserve the right to amend these Terms at any time. Any changes will be effective immediately upon posting.
              </p>
            </section>

            {/* Applicable Law Section */}
            <section>
              <h2>Applicable Law and Jurisdiction</h2>
              <p>
                These Terms and Conditions, and your use of the Platform, are governed by the laws of the State of Georgia, United States. Any disputes will be subject to the jurisdiction of the courts in the United States.
              </p>
            </section>

            <footer>
              <p>
                NO PURCHASE NECESSARY to enter Sweepstakes. SWEEPSTAKES ARE VOID WHERE PROHIBITED BY LAW.
              </p>
            </footer>
          </article>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
